<script lang="ts">
  import type { NewsletterStoryblok } from '$types/bloks';

  import Title from '$components/title.svelte';
  import HubspotForm from '$components/hubspot-form.svelte';
  import Background from '$components/newsletter/background.svelte';

  export let blok: NewsletterStoryblok;
  $: ({ title, form } = blok);
</script>

<section class="flex w-full items-center overflow-hidden">
  <div class="container relative mx-auto flex items-center justify-center xl:h-[486px]">
    <Background />
    <div
      class="flex max-w-[744px] flex-col items-center justify-center gap-24 px-20 py-48 xl:px-48"
    >
      {#if title?.[0]}
        <Title data={title[0]} class="max-w-[532px] items-center text-center xl:items-center" />
      {/if}

      <div class="flex h-fit w-full max-w-[385px]">
        {#if form && form.length && form?.[0].form}
          {@const formId = form?.[0].form}
          {#if formId}
            <HubspotForm form={formId} skeleton="newsletter" />
          {/if}
        {/if}
      </div>
    </div>
  </div>
</section>
